import React from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';

import { PickListDropdownSetting } from '../../../../../picking/printed-section/printed-section-settings/pick-list-dropdown-setting';

import { useEnableNewLayoutOptions } from '../../../../../../../../feature-flags/hooks/use-enable-new-layout-options';
import { useLabelOutput } from '../../../../../../../../hooks/use-seller-setting';
import {
  defaultPackingSlipFormats,
  INCLUDES_PACKING_SLIP_SUFFIX,
  newPackingSlipFormats,
  newPackingSlipFormatsFromLabel,
  packingSlipFormatsFromLabel,
} from '../../../../../../printing/document-option-modal/packing-slip/constants';

import packingSlipMessages from '../../../../../../printing/document-option-modal/packing-slip/messages';
import { FORM_FIELDS } from '../../constants';
import messages from '../../messages';
import style from '../../style.module.less';

/**
 * @param {{
 *   value: string,
 *   onChange: (field: string, value: string) => void
 * }} props
 * @returns {JSX.Element}
 */
export const PackingSlipFormatDropdown = ({ value, onChange }) => {
  const intl = useIntl();
  const labelOutput = useLabelOutput();
  const labelIncludesPackingSlip = labelOutput.includes(INCLUDES_PACKING_SLIP_SUFFIX);
  // TODO: [SPD-19601]: use new layout by default, can be simplified in SPD-19601
  const packingSlipFormats = [...defaultPackingSlipFormats, ...newPackingSlipFormats];
  const enableNewLayoutOptions = useEnableNewLayoutOptions();
  const currentPackingSlipFormatsFromLabel = enableNewLayoutOptions
    ? [...packingSlipFormatsFromLabel, ...newPackingSlipFormatsFromLabel]
    : packingSlipFormatsFromLabel;

  const dropdownItems = packingSlipFormats.map(({ messageDescriptor, value: optionValue }) => ({
    key: optionValue,
    name: intl.formatMessage(messageDescriptor),
  }));

  const handleChange = (selectedValue) => {
    onChange(FORM_FIELDS.PACKING_SLIP_FORMAT, selectedValue);
  };

  return (
    <FlexColumn className={style['section-row']}>
      <PickListDropdownSetting
        descriptionMessage={labelIncludesPackingSlip ? messages.packingSlipOnLabelWarning : null}
        disabled={labelIncludesPackingSlip}
        items={
          labelIncludesPackingSlip
            ? currentPackingSlipFormatsFromLabel.map(({ messageDescriptor, value: optionValue }) => ({
                key: optionValue,
                name: intl.formatMessage(messageDescriptor),
              }))
            : dropdownItems
        }
        onChange={handleChange}
        titleMessage={packingSlipMessages.packingSlipFormatLabel}
        value={labelIncludesPackingSlip ? labelOutput : value}
      />
    </FlexColumn>
  );
};
